"use client";

import { c as _c } from "react/compiler-runtime";
import { FiCheckSquare, FiEdit3 } from "react-icons/fi";
import { DropdownMenuItem } from "@/components/ui/dropdown";
import { useTenant } from "@/contexts/tenant-provider";
import { useUser } from "@/contexts/user-provider";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { useSetNoteCompletionMutation } from "@/api/provider/scribe/note-mutation";

/**
 * "Mark complete" — the author saying the chart is finished.
 *
 * Only offered where the clinic requires it; a signed note is finished by
 * definition, so it cannot be returned to a draft from here.
 */
export function NoteCompletionMenuItem(t0) {
  const $ = _c(11);
  const {
    noteId,
    completedDate,
    isSignedOff
  } = t0;
  const {
    currentUser
  } = useUser();
  const {
    tenant
  } = useTenant();
  const completionMutation = useSetNoteCompletionMutation();
  if (!tenant?.requireNoteCompletion) {
    return null;
  }
  if (isSignedOff) {
    return null;
  }
  if (!hasPermission(currentUser, PERMISSIONS.PATIENTS_NOTES_WRITE)) {
    return null;
  }
  const isComplete = !!completedDate;
  let t1;
  if ($[0] !== isComplete) {
    t1 = isComplete ? <FiEdit3 className="h-4 w-4" /> : <FiCheckSquare className="h-4 w-4" />;
    $[0] = isComplete;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== completionMutation || $[3] !== isComplete || $[4] !== noteId) {
    t2 = e => {
      e.preventDefault();
      completionMutation.mutate({
        noteId,
        isComplete: !isComplete
      });
    };
    $[2] = completionMutation;
    $[3] = isComplete;
    $[4] = noteId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isComplete ? "Reopen as draft" : "Mark complete";
  let t4;
  if ($[6] !== completionMutation.isPending || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <DropdownMenuItem disabled={completionMutation.isPending} icon={t1} onSelect={t2}>{t3}</DropdownMenuItem>;
    $[6] = completionMutation.isPending;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}